/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeSelfShutdownAcknowledgedDto,
  ApiEnvelopeSelfShutdownIncidentListDto,
  ApiEnvelopeSelfShutdownIncidentReportDto
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type botSelfShutdownListOpenResponse200 = {
  data: ApiEnvelopeSelfShutdownIncidentListDto
  status: 200
}

export type botSelfShutdownListOpenResponse401 = {
  data: ApiEnvelopeSelfShutdownIncidentListDto
  status: 401
}

export type botSelfShutdownListOpenResponseSuccess = (botSelfShutdownListOpenResponse200) & {
  headers: Headers;
};
export type botSelfShutdownListOpenResponseError = (botSelfShutdownListOpenResponse401) & {
  headers: Headers;
};

export type botSelfShutdownListOpenResponse = (botSelfShutdownListOpenResponseSuccess | botSelfShutdownListOpenResponseError)

export const getBotSelfShutdownListOpenUrl = () => {




  return `/api/botengine/selfshutdown/open`
}

export const useBotSelfShutdownListOpenHook = (): ( options?: RequestInit) => Promise<botSelfShutdownListOpenResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getBotSelfShutdownListOpenUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type botSelfShutdownListForBotResponse200 = {
  data: ApiEnvelopeSelfShutdownIncidentListDto
  status: 200
}

export type botSelfShutdownListForBotResponse401 = {
  data: ApiEnvelopeSelfShutdownIncidentListDto
  status: 401
}

export type botSelfShutdownListForBotResponse403 = {
  data: ApiEnvelopeSelfShutdownIncidentListDto
  status: 403
}

export type botSelfShutdownListForBotResponseSuccess = (botSelfShutdownListForBotResponse200) & {
  headers: Headers;
};
export type botSelfShutdownListForBotResponseError = (botSelfShutdownListForBotResponse401 | botSelfShutdownListForBotResponse403) & {
  headers: Headers;
};

export type botSelfShutdownListForBotResponse = (botSelfShutdownListForBotResponseSuccess | botSelfShutdownListForBotResponseError)

export const getBotSelfShutdownListForBotUrl = (botId: string,) => {




  return `/api/botengine/selfshutdown/bot/${botId}`
}

export const useBotSelfShutdownListForBotHook = (): (botId: string, options?: RequestInit) => Promise<botSelfShutdownListForBotResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getBotSelfShutdownListForBotUrl(botId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type botSelfShutdownGetReportResponse200 = {
  data: ApiEnvelopeSelfShutdownIncidentReportDto
  status: 200
}

export type botSelfShutdownGetReportResponse401 = {
  data: ApiEnvelopeSelfShutdownIncidentReportDto
  status: 401
}

export type botSelfShutdownGetReportResponse403 = {
  data: ApiEnvelopeSelfShutdownIncidentReportDto
  status: 403
}

export type botSelfShutdownGetReportResponse404 = {
  data: ApiEnvelopeSelfShutdownIncidentReportDto
  status: 404
}

export type botSelfShutdownGetReportResponseSuccess = (botSelfShutdownGetReportResponse200) & {
  headers: Headers;
};
export type botSelfShutdownGetReportResponseError = (botSelfShutdownGetReportResponse401 | botSelfShutdownGetReportResponse403 | botSelfShutdownGetReportResponse404) & {
  headers: Headers;
};

export type botSelfShutdownGetReportResponse = (botSelfShutdownGetReportResponseSuccess | botSelfShutdownGetReportResponseError)

export const getBotSelfShutdownGetReportUrl = (incidentId: string,) => {




  return `/api/botengine/selfshutdown/${incidentId}`
}

export const useBotSelfShutdownGetReportHook = (): (incidentId: string, options?: RequestInit) => Promise<botSelfShutdownGetReportResponse> => {

      const customFetcher = useSfetchMutator();
      return (incidentId: string, options?: RequestInit) => {

        return customFetcher(getBotSelfShutdownGetReportUrl(incidentId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type botSelfShutdownAcknowledgeResponse200 = {
  data: ApiEnvelopeSelfShutdownAcknowledgedDto
  status: 200
}

export type botSelfShutdownAcknowledgeResponse401 = {
  data: ApiEnvelopeSelfShutdownAcknowledgedDto
  status: 401
}

export type botSelfShutdownAcknowledgeResponse403 = {
  data: ApiEnvelopeSelfShutdownAcknowledgedDto
  status: 403
}

export type botSelfShutdownAcknowledgeResponse404 = {
  data: ApiEnvelopeSelfShutdownAcknowledgedDto
  status: 404
}

export type botSelfShutdownAcknowledgeResponseSuccess = (botSelfShutdownAcknowledgeResponse200) & {
  headers: Headers;
};
export type botSelfShutdownAcknowledgeResponseError = (botSelfShutdownAcknowledgeResponse401 | botSelfShutdownAcknowledgeResponse403 | botSelfShutdownAcknowledgeResponse404) & {
  headers: Headers;
};

export type botSelfShutdownAcknowledgeResponse = (botSelfShutdownAcknowledgeResponseSuccess | botSelfShutdownAcknowledgeResponseError)

export const getBotSelfShutdownAcknowledgeUrl = (incidentId: string,) => {




  return `/api/botengine/selfshutdown/${incidentId}/acknowledge`
}

export const useBotSelfShutdownAcknowledgeHook = (): (incidentId: string, options?: RequestInit) => Promise<botSelfShutdownAcknowledgeResponse> => {

      const customFetcher = useSfetchMutator();
      return (incidentId: string, options?: RequestInit) => {

        return customFetcher(getBotSelfShutdownAcknowledgeUrl(incidentId),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


